/* The Puptail Society 2026 theme: content data (Foundation).
 * GENERATED from the approved draft (wip/puptails/assets/js/site.js). Edit the draft data and regenerate,
 * or edit carefully by hand. Keyed by the REAL Shopify handle; slug = the draft key.
 * Image paths are draft-relative ("luxe/glass.jpg"); resolve with PTS.img(path). Prices are live from PTS_SHOP;
 * "fallback" prices are only used if the catalog snippet returned no products. */
window.PTS_CONTENT = {
 "version": "2026-10-14",
 "SLUGS": {
  "muttini": "muttini",
  "jackhatten": "jackhatten",
  "brosecco": "brosecco",
  "negruffi": "negruffi",
  "bark-n-bourbon": "bark-n-bourbon",
  "barkarita": "barkarita-1",
  "tailgroni": "tailgroni-1",
  "bondi-spritz": "bondi-spritz-the-post-play-refresher",
  "yappy-hour-sampler": "the-yappy-hour-sampler",
  "pawty-pack": "the-slurp-mat",
  "charcuterie": "puptails-dog-grazing-box-gourmet-dog-treat-gift-box",
  "poochtini-glass": "the-puptails-glass",
  "5pm-tote": "5pm-tote",
  "gift-card": "the-puptail-society-gift-card",
  "society-mat": "society-mat"
 },
 "DRINKS": {
  "muttini": {
   "slug": "muttini",
   "h": "muttini",
   "t": "Muttini",
   "kind": "drink",
   "range": "heritage",
   "job": "Hip & joint",
   "boost": "Joint-Loving Omega Boost",
   "extra": "Fruity Antioxidant Freshness",
   "badge": "House favourite",
   "line": "Barrelled beef broth with apple twist reduction",
   "about": "Muttini is formulated to rehydrate and support hip and joint mobility.",
   "notes": [
    "Barrelled beef broth",
    "Crisp green apple",
    "Long, joint loving"
   ],
   "ing": "Beef Broth, Purified Inner-Leaf Aloe Vera, DHA/EPA (Omega-3 Powder), Vitamin C, Apple Pectin, Methylsulfonylmethane (MSM), Type II Collagen, Hyaluronic Acid, Glucosamine Hydrochloride.",
   "key": [
    [
     "Glucosamine + MSM",
     "Joint support"
    ],
    [
     "Type II Collagen",
     "Cartilage"
    ],
    [
     "Omega-3",
     "Mobility"
    ],
    [
     "Inner-Leaf Aloe Vera",
     "Hydration"
    ]
   ],
   "img": "pack/muttini-luxe.jpg",
   "pouch": "pouch/muttini-luxe.jpg",
   "hover": "real/khaleesi-muttini.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "jackhatten": {
   "slug": "jackhatten",
   "h": "jackhatten",
   "t": "Jackhatten",
   "kind": "drink",
   "range": "heritage",
   "job": "Brain & focus",
   "boost": "Brain Loving Omega Goodness",
   "line": "Aged beef broth with sweet potato extract",
   "about": "Jackhatten is formulated to rehydrate and support cognitive vitality.",
   "notes": [
    "Aged beef broth",
    "Roasted sweet potato",
    "Earthy beetroot warmth"
   ],
   "ing": "Beef Broth, Purified Inner-Leaf Aloe Vera, DHA/EPA (Omega-3), Beetroot Powder, Sweet Potato, Curcumin, Alpha-Lipoic Acid, Niacinamide (B3), Hydrolysed Collagen.",
   "key": [
    [
     "Omega-3 DHA/EPA",
     "Brain health"
    ],
    [
     "Curcumin",
     "Antioxidant"
    ],
    [
     "Alpha-Lipoic Acid",
     "Vitality"
    ],
    [
     "Sweet Potato",
     "Fibre"
    ]
   ],
   "img": "pack/jackhatten-luxe.jpg",
   "pouch": "pouch/jackhatten-luxe.jpg",
   "hover": "real/khaleesi-jackhatten.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "brosecco": {
   "slug": "brosecco",
   "h": "brosecco",
   "t": "Brosecco",
   "kind": "drink",
   "range": "heritage",
   "job": "Skin & coat",
   "boost": "Skin Loving Carrot Boost",
   "line": "Brewed chicken broth, carrot and aloe vera spritz",
   "about": "Brosecco is formulated to rehydrate and nourish skin and coat health.",
   "notes": [
    "Golden chicken broth",
    "Sweet carrot",
    "Bright, glossy finish"
   ],
   "ing": "Chicken Broth, Purified Inner-Leaf Aloe Vera, Beta Carotene (carrot), DHA/EPA (Omega-3), Vitamin E, Biotin, Zinc, Hydrolysed Marine Collagen Peptides, Hydrolysed Collagen.",
   "key": [
    [
     "Biotin + Zinc",
     "Coat shine"
    ],
    [
     "Marine Collagen",
     "Skin"
    ],
    [
     "Vitamin E",
     "Antioxidant"
    ],
    [
     "Beta Carotene",
     "Carrot goodness"
    ]
   ],
   "img": "pack/brosecco-luxe.jpg",
   "pouch": "pouch/brosecco-luxe.jpg",
   "hover": "real/colour-brosecco.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "negruffi": {
   "slug": "negruffi",
   "h": "negruffi",
   "t": "Negruffi",
   "kind": "drink",
   "range": "heritage",
   "job": "Gut comfort",
   "boost": "Gut-Friendly Fibre Boost",
   "line": "Blended beef broth, pumpkin and orange tonic",
   "about": "Negruffi is formulated to rehydrate and support gut comfort.",
   "notes": [
    "Rich beef broth",
    "Velvet pumpkin",
    "A twist of orange"
   ],
   "ing": "Beef Broth, Purified Inner-Leaf Aloe Vera, Probiotics, Prebiotics, Pumpkin Powder, L-Glutamine, Inulin, Pectin (Apple), Orange, Hydrolysed Collagen.",
   "key": [
    [
     "Pro + Prebiotics",
     "Gut flora"
    ],
    [
     "Pumpkin",
     "Gentle fibre"
    ],
    [
     "L-Glutamine",
     "Gut lining"
    ],
    [
     "Inulin",
     "Digestion"
    ]
   ],
   "img": "pack/negruffi-luxe.jpg",
   "pouch": "pouch/negruffi-luxe.jpg",
   "hover": "real/colour-negruffi.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "bark-n-bourbon": {
   "slug": "bark-n-bourbon",
   "h": "bark-n-bourbon",
   "t": "Bark N' Bourbon",
   "kind": "drink",
   "range": "heritage",
   "job": "Calm & relax",
   "boost": "Calming Botanical Blend",
   "line": "Crafted chicken broth, blueberry and passionflower botanicals",
   "about": "Bark N' Bourbon is formulated to rehydrate and promote calm relaxation.",
   "notes": [
    "Smooth chicken broth",
    "Ripe blueberry",
    "Soft passionflower close"
   ],
   "ing": "Chicken Broth, Purified Inner-Leaf Aloe Vera, L-Theanine, L-Tryptophan, Valerian Root Extract, Passionflower Extract, Magnesium, Vitamin B1 (Thiamine), Blueberry, Hydrolysed Collagen.",
   "key": [
    [
     "L-Theanine",
     "Calm"
    ],
    [
     "Passionflower",
     "Relaxation"
    ],
    [
     "Valerian Root",
     "Rest"
    ],
    [
     "Magnesium",
     "Nerves"
    ]
   ],
   "img": "pack/bark-n-bourbon-luxe.jpg",
   "pouch": "pouch/bark-n-bourbon-luxe.jpg",
   "hover": "real/khaleesi-bark.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "barkarita-1": {
   "slug": "barkarita",
   "h": "barkarita-1",
   "t": "Barkarita",
   "kind": "drink",
   "range": "mixed",
   "job": "Brain & focus",
   "boost": "Brain Loving Omega Goodness",
   "line": "Pressed beef broth with sweet potato extract",
   "about": "Barkarita is formulated to rehydrate and support cognitive vitality.",
   "notes": [
    "Pressed beef broth",
    "Sweet potato",
    "Clean, bright finish"
   ],
   "ing": "Beef Broth, Purified Inner-Leaf Aloe Vera, DHA/EPA (Omega-3), Beetroot Powder, Sweet Potato, Curcumin, Alpha-Lipoic Acid, Niacinamide (B3), Hydrolysed Collagen.",
   "key": [
    [
     "Omega-3 DHA/EPA",
     "Brain health"
    ],
    [
     "Beetroot",
     "Circulation"
    ],
    [
     "Curcumin",
     "Antioxidant"
    ],
    [
     "Inner-Leaf Aloe Vera",
     "Hydration"
    ]
   ],
   "img": "pack/barkarita-luxe.jpg",
   "pouch": "pouch/barkarita-luxe.jpg",
   "hover": "real/fluffy-barkarita.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "tailgroni-1": {
   "slug": "tailgroni",
   "h": "tailgroni-1",
   "t": "Tailgroni",
   "kind": "drink",
   "range": "mixed",
   "job": "Gut comfort",
   "boost": "Gut-Friendly Fibre Boost",
   "line": "Blended beef broth, pumpkin and orange tonic",
   "about": "Tailgroni is formulated to rehydrate and support gut comfort.",
   "notes": [
    "Light beef broth",
    "Pumpkin",
    "Orange peel brightness"
   ],
   "ing": "Beef Broth, Purified Inner-Leaf Aloe Vera, Probiotics, Prebiotics, Pumpkin Powder, L-Glutamine, Inulin, Pectin (Apple), Orange, Hydrolysed Collagen.",
   "key": [
    [
     "Pro + Prebiotics",
     "Gut flora"
    ],
    [
     "Pumpkin",
     "Gentle fibre"
    ],
    [
     "L-Glutamine",
     "Gut lining"
    ],
    [
     "Orange",
     "Vitamin C"
    ]
   ],
   "img": "pack/tailgroni-luxe.jpg",
   "pouch": "pouch/tailgroni-luxe.jpg",
   "hover": "real/colour-negruffi.jpg",
   "fallback": {
    "p150": 15.95,
    "p75": 9.95
   }
  },
  "bondi-spritz-the-post-play-refresher": {
   "slug": "bondi-spritz",
   "h": "bondi-spritz-the-post-play-refresher",
   "t": "Bondi Spritz",
   "kind": "drink",
   "range": "limited",
   "job": "Energy & recovery",
   "boost": "Energy & Recovery Support",
   "badge": "Dr Kate limited edition",
   "line": "Distilled coconut water with a watermelon infusion",
   "about": "Bondi Spritz is the post play refresher, created with Dr Kate Adams. It is formulated to rehydrate and support energy recharge.",
   "notes": [
    "Coconut water",
    "Fresh watermelon",
    "Light beef broth base"
   ],
   "ing": "Purified Inner-Leaf Aloe Vera, Coconut Water Powder, Beef Broth, L-Carnitine, Ashwagandha, Watermelon, L-Glutamine, B-Complex Vitamins, Hydrolysed Collagen.",
   "key": [
    [
     "Coconut Water",
     "Electrolytes"
    ],
    [
     "L-Carnitine",
     "Energy"
    ],
    [
     "Ashwagandha",
     "Recovery"
    ],
    [
     "B-Complex",
     "Vitality"
    ]
   ],
   "only150": true,
   "img": "pack/bondi-spritz-luxe.jpg",
   "pouch": "pouch/bondi-spritz-luxe.jpg",
   "hover": "real/khaleesi-bondi.jpg",
   "fallback": {
    "p150": 18.95,
    "p75": 9.95
   }
  }
 },
 "EXTRAS": {
  "the-yappy-hour-sampler": {
   "slug": "yappy-hour-sampler",
   "h": "the-yappy-hour-sampler",
   "t": "Yappy Hour Sampler",
   "kind": "set",
   "badge": "Save $13.80",
   "line": "Five 75ml minis in the Heritage or Mixed flight. A cocktail flight for dogs.",
   "img": "luxe/heritage.jpg",
   "imgs": [
    "real/sampler-2.jpg"
   ],
   "fallback": {
    "price": 35.95
   }
  },
  "the-slurp-mat": {
   "slug": "pawty-pack",
   "h": "the-slurp-mat",
   "t": "Pawty Pack",
   "kind": "set",
   "line": "Society Mat, Poochtini Glass and a 150ml Puptail of your choice.",
   "about": "The Poochtini Glass and Society Mat work together to create a stylish, mess free (and very Instagram worthy) serving moment.",
   "boosts": [
    "Mess free serving",
    "Dishwasher safe",
    "Freezer friendly mat",
    "Choose any core Puptail"
   ],
   "includes": [
    "1 x Society Mat",
    "1 x Poochtini Glass",
    "1 x 150ml Puptail (excludes Limited Editions)"
   ],
   "specs": [
    [
     "Society Mat",
     "Food grade silicone, dishwasher safe"
    ],
    [
     "Mat size",
     "200mm diameter, 20mm base"
    ],
    [
     "Poochtini Glass",
     "Polycarbonate, dishwasher safe"
    ],
    [
     "Glass size",
     "Holds 225ml, 150mm tall"
    ]
   ],
   "img": "luxe/pawty.jpg",
   "imgs": [
    "luxe/pawty.jpg",
    "luxe/ritual.jpg",
    "luxe/glass.jpg"
   ],
   "fallback": {
    "price": 42.95
   }
  },
  "puptails-dog-grazing-box-gourmet-dog-treat-gift-box": {
   "slug": "charcuterie",
   "h": "puptails-dog-grazing-box-gourmet-dog-treat-gift-box",
   "t": "Gourmet Dog Charcuterie Box",
   "kind": "gift",
   "line": "Dog safe treats, artisan style cheese bites and jerky for 1 to 2 dogs.",
   "about": "The perfect little pairing with a Puptail. A gourmet grazing experience for 1 to 2 dogs, made for date nights, park picnics, hotel stays, birthdays and Gotcha Days. Australian made and beautifully presented. Grazing, reimagined for dogs.",
   "boosts": [
    "Pairs perfectly with a Puptail",
    "Charcuterie style treats",
    "Australian made",
    "Serves 1 to 2 dogs"
   ],
   "includes": [
    "5 x olive style biscuits",
    "5 x almond shaped vanilla and carob yoghurt drops (no added sugar)",
    "2 x banana yoghurt cheese bites (no added sugar)",
    "2 x artisan crackers",
    "Mixed chicken and beef jerky bites"
   ],
   "ingText": "Olive style biscuits: wholemeal flour, organic coconut, Australian honey. Cheese bites: no added sugar banana yoghurt. Almond treats: no added sugar vanilla yoghurt and carob. Jerky: chicken and beef lung. Crackers: wholemeal flour, organic coconut, Australian honey.",
   "care": "Best enjoyed fresh. Store in a cool dry place and reseal after opening. Serve as an occasional treat, supervise while enjoying, and always provide fresh water or a Puptail.",
   "img": "luxe/charcuterie.jpg",
   "imgs": [
    "luxe/charcuterie.jpg",
    "luxe/gift.jpg",
    "real/charcuterie-2.jpg"
   ],
   "fallback": {
    "price": 29.95
   }
  },
  "the-puptails-glass": {
   "slug": "poochtini-glass",
   "h": "the-puptails-glass",
   "t": "Poochtini Glass",
   "kind": "acc",
   "line": "The signature coupe. Lightweight, dog friendly, dishwasher safe.",
   "about": "Because every Puptail deserves to be served in style. Lightweight and dog friendly, stylish enough for celebrations and practical enough for every 5pm ritual. Serve Puptails chilled, frozen or dressed up with their favourite garnish.",
   "boosts": [
    "Durable and reusable",
    "Dishwasher safe",
    "Lightweight",
    "Made for Puptails"
   ],
   "specs": [
    [
     "Material",
     "Polycarbonate, dishwasher safe"
    ],
    [
     "Holds",
     "225ml"
    ],
    [
     "Stem height",
     "91mm"
    ],
    [
     "Total height",
     "150mm"
    ]
   ],
   "img": "luxe/glass.jpg",
   "imgs": [
    "luxe/glass.jpg",
    "luxe/pawty.jpg",
    "luxe/ritual.jpg"
   ],
   "fallback": {
    "price": 15.95
   }
  },
  "society-mat": {
   "slug": "society-mat",
   "h": "society-mat",
   "t": "Society Mat",
   "kind": "acc",
   "line": "Lick mat and slow feeder in one. Pour, freeze, lick, repeat.",
   "about": "The Society Mat is the slow feeder our members rave about. Pour a Puptail into the rings and freeze it for a long lasting summer treat, or spread dinner across it to slow down speedy eaters. The Poochtini Glass sits perfectly in the centre for a mess free Yappy Hour.",
   "boosts": [
    "Slow feeder",
    "Freezer friendly",
    "Dishwasher safe",
    "Fits the Poochtini Glass"
   ],
   "specs": [
    [
     "Material",
     "Food grade silicone, dishwasher safe"
    ],
    [
     "Size",
     "200mm diameter, 20mm base"
    ],
    [
     "Use",
     "Lick mat, slow feeder or glass coaster"
    ]
   ],
   "img": "real/pawty-pack-1.jpg",
   "imgs": [
    "real/pawty-pack-1.jpg",
    "real/glass-0.jpg",
    "dogs/way-freeze.jpg"
   ],
   "fallback": {
    "price": 21.95
   },
   "optional": true
  },
  "5pm-tote": {
   "slug": "5pm-tote",
   "h": "5pm-tote",
   "t": "5pm Tote",
   "kind": "acc",
   "line": "Cotton, gold print. For park runs, refills and cheeky 5pm adventures.",
   "about": "The perfect grab and go cotton tote for park trips, Puptail refills or a cheeky 5pm adventure. Gold print, light and stylish.",
   "specs": [
    [
     "Size",
     "40cm high x 37cm wide"
    ],
    [
     "Gusset",
     "10cm"
    ],
    [
     "Handle drop",
     "30cm"
    ],
    [
     "Print",
     "Gold"
    ]
   ],
   "img": "real/tote-0.jpg",
   "imgs": [
    "real/tote-0.jpg",
    "real/tote-1.jpg",
    "real/tote-2.jpg"
   ],
   "fallback": {
    "price": 12.95
   }
  },
  "the-puptail-society-gift-card": {
   "slug": "gift-card",
   "h": "the-puptail-society-gift-card",
   "t": "Pawsome Gift Card",
   "kind": "gift",
   "line": "From $30 to $200. For the dog who has everything.",
   "about": "A deliciously easy gift for the doggo who has everything. The Pawsome Gift Card unlocks Puptails, accessories and endless 5pm fun. Delivered by email, ready to forward.",
   "img": "luxe/giftcard.jpg",
   "imgs": [
    "luxe/giftcard.jpg",
    "luxe/giftcard-face.jpg"
   ],
   "from": true,
   "fallback": {
    "price": 30
   }
  }
 },
 "SERVE": "Preferably shaken, not stirred. Serve room temperature, chilled, frozen for a cool twist, poured as a topper, or straight from the pouch on the go. One 150ml pouch is 3 to 4 serves for small dogs, or 1 to 2 serves for medium and large dogs.",
 "SAFETY": "Only ingredients approved for dogs, including the occasional human grade colouring for those bright Puptail colours. Every blend is alcohol free, grape free and free from anything harmful to pups. All formulas have been reviewed and endorsed by Dr Kate Adams.",
 "REVIEWS": [
  [
   "The curved coupe shape, the crystal clear finish and the gold logo give it that boutique cocktail bar feel.",
   "Chervonne J.",
   "Poochtini Glass"
  ],
  [
   "Just a really sweet way to spoil my pup with something different other than biscuit treats.",
   "Mary P.",
   "Verified buyer"
  ],
  [
   "Brilliant idea! And Otis loved everything in the box!",
   "Benjamin W.",
   "Charcuterie Box"
  ],
  [
   "They’re sturdy and the perfect height for my two cavoodles.",
   "Alice C.",
   "Verified buyer"
  ]
 ],
 "PHOTO_REVIEWS": [
  {
   "img": "real/review-carrie.jpg",
   "text": "Our big girl couldn’t pick a favourite. She powered through the Yappy Hour Sampler and loved every single flavour. For a dog her size to get this excited says everything. Consider her officially part of the Society.",
   "name": "Carrie",
   "who": "English Mastiff owner"
  },
  {
   "img": "real/review-suzanne.jpg",
   "text": "Our little 6 month old Schnauzer woofed her Puptail down in seconds. A huge winner for her, and she loves it even more frozen. Such a great idea for these warmer months!",
   "name": "Suzanne",
   "who": "Schnauzer owner"
  },
  {
   "img": "real/review-mary.jpg",
   "text": "Just gave little 12 week old Coco her first Puptail. Look at that cute little mouth wanting more. She gobbled it up faster than I can get through a cocktail. The Yappy Hour Sampler is next.",
   "name": "Mary",
   "who": "French Bulldog owner"
  },
  {
   "img": "real/review-sally.jpg",
   "text": "These two fussy eaters devoured the Bondi Spritz. Here they are chilling on the couch like royalty after their Puptail. Cheers to pawsing and unwinding, their new fave ritual.",
   "name": "Sally",
   "who": "Oodle owner"
  }
 ],
 "FAQ": [
  {
   "id": "safety",
   "t": "Safety & Ingredients",
   "q": [
    [
     "Are Puptails safe for all dogs?",
     "<p>Absolutely. Every Puptail is made with 100% human food grade ingredients, is vet approved, and contains no alcohol and no nasties. If your dog has sensitivities, show the ingredients to your vet. Puptails are designed for even the fussiest pups.</p>"
    ],
    [
     "Can puppies drink Puptails?",
     "<p>Yes, puppies deserve a Yappy Hour too. Puptails are safe for pups over 12 weeks. Start with a small amount to let tiny tummies adjust.</p>"
    ],
    [
     "What exactly goes into a Puptail?",
     "<p>Only the good stuff:</p><ul><li>100% human grade ingredients</li><li>A coconut water, beef broth or chicken broth base, depending on the Puptail</li><li>Functional ingredients like probiotics, L-theanine, omega-3s and gut friendly nutrients</li><li>No alcohol. No grapes. No questionable ingredients.</li></ul>"
    ],
    [
     "Are there health benefits?",
     "<p>Yes. Every Puptail offers healthy hydration plus a targeted wellness boost, such as skin and coat support, gut health, calming ingredients or energy and recovery. Think of it as a liquid treat that actually does something good.</p>"
    ],
    [
     "Is Puptails vet approved?",
     "<p>Yes. Every ingredient has been reviewed and approved by Dr Kate Adams of Bondi Vet Hospital, an ambassador and partner of The Puptail Society.</p>"
    ],
    [
     "Can humans drink Puptails?",
     "<p>Technically, yes. Every Puptail is 100% human grade, but they are formulated for dogs. We promise they taste much better to your four legged bestie.</p>"
    ]
   ]
  },
  {
   "id": "serving",
   "t": "Serving & Rituals",
   "q": [
    [
     "How do I serve a Puptail?",
     "<p>Four ways: room temperature for on the go, chilled for the ultimate summer vibe, frozen on the Society Mat for a long lasting treat, or poured over their food as a topper.</p>"
    ],
    [
     "How often can I give my dog a Puptail?",
     "<p>Puptails are a treat based drink, perfect for a daily Yappy Hour, weekends, or whenever your dog deserves a little extra fun. One pouch a day is ideal for most dogs.</p>"
    ],
    [
     "How many serves are in a Puptail?",
     "<p>Each 150ml Puptail is 3 to 4 serves for small dogs, or 1 to 2 serves for medium and large dogs. The 75ml Sampler minis are exactly half that.</p><div class=\"sizing\"><div><b>Small</b>Up to 10kg</div><div><b>Medium</b>10 to 25kg</div><div><b>Large</b>25kg and over</div></div>"
    ],
    [
     "Can Puptails replace water?",
     "<p>No. They are a fun, hydrating treat, not a water replacement. Always keep fresh water available.</p>"
    ]
   ]
  },
  {
   "id": "storage",
   "t": "Storage & Shelf Life",
   "q": [
    [
     "How should I store Puptails?",
     "<p>Store unopened Puptails in a cool, dry place away from direct sunlight. Please refer to the expiry date stamped on the back of each pouch. Once opened, refrigerate and use within 7 days.</p>"
    ],
    [
     "Do Puptails need refrigerating before opening?",
     "<p>No. Every Puptail is shelf stable. Chill it only if your pup prefers it cold.</p>"
    ]
   ]
  },
  {
   "id": "shipping",
   "t": "Shipping & Returns",
   "q": [
    [
     "How long does shipping take?",
     "<p>Orders are packed and dispatched within 1 to 2 business days. Australia: 2 to 7 business days. New Zealand: 5 to 12 business days.</p>"
    ],
    [
     "Do you offer free shipping?",
     "<p>Yes, free shipping on Australian orders over ${freeShip}. Consider it our shout. New Zealand shipping is calculated at checkout.</p>"
    ],
    [
     "Do you ship internationally?",
     "<p>We currently ship to New Zealand, with more of the world joining the Society soon.</p>"
    ],
    [
     "What is your returns policy?",
     "<p>For hygiene and safety reasons we cannot accept returns on consumable products. If something is not right, let us know within 7 days and we will make it right with a refund (less shipping).</p>"
    ]
   ]
  },
  {
   "id": "where",
   "t": "Where to Find",
   "q": [
    [
     "Where can I find Puptails?",
     "<p>Shop online right here, or visit one of nearly 40 stockists across NSW, VIC, QLD, ACT, SA and New Zealand, from Bondi Vet to InterContinental Double Bay. <a href=\"{url:stockists}\" style=\"text-decoration:underline\">Find a stockist</a>.</p>"
    ],
    [
     "Can I buy single pouches or mixed packs?",
     "<p>Yes. Buy any flavour on its own in 150ml or 75ml, or start with the Yappy Hour Sampler.</p>"
    ],
    [
     "Can my business stock Puptails?",
     "<p>We would love that. Apply through our <a href=\"{url:wholesale}\" style=\"text-decoration:underline\">wholesale portal</a> or send us a note on the contact page.</p>"
    ]
   ]
  }
 ],
 "WAYS": [
  {
   "t": "Sip & Refresh",
   "p": "Pour into a bowl or the Poochtini Glass as a luxe upgrade to plain water.",
   "img": "real/colour-bondi.jpg",
   "alt": "Bondi Spritz poured in a coupe"
  },
  {
   "t": "Top & Enhance",
   "p": "Drizzle over dinner to elevate everyday dry food. Fussy eaters, sorted.",
   "img": "dogs/way-top.jpg",
   "alt": "A French bulldog watching a Puptail poured over dinner"
  },
  {
   "t": "Freeze & Treat",
   "p": "Pour onto the Society Mat and freeze for a long lasting summer snack.",
   "img": "dogs/way-freeze.jpg",
   "alt": "A dog licking a frozen Puptail on the Society Mat"
  },
  {
   "t": "Shake & Go",
   "p": "Straight from the pouch, perfect for adventures and quick sips.",
   "img": "real/khaleesi-beach.jpg",
   "alt": "Khaleesi on a beach walk with a Puptail and the 5pm Tote"
  }
 ],
 "LIFE": {
  "muttini": "khaleesi-muttini",
  "jackhatten": "khaleesi-jackhatten",
  "bark-n-bourbon": "khaleesi-bark",
  "bondi-spritz-the-post-play-refresher": "khaleesi-bondi",
  "barkarita-1": "fluffy-barkarita"
 },
 "COLOUR": {
  "muttini": "colour-muttini",
  "jackhatten": "colour-jack",
  "barkarita-1": "colour-jack",
  "brosecco": "colour-brosecco",
  "negruffi": "colour-negruffi",
  "tailgroni-1": "colour-negruffi",
  "bark-n-bourbon": "colour-bark",
  "bondi-spritz-the-post-play-refresher": "colour-bondi"
 },
 "LAUNCH": {
  "tailgroni-1": "launch-tailgroni",
  "negruffi": "launch-negruffi",
  "barkarita-1": "launch-barkarita",
  "bondi-spritz-the-post-play-refresher": "launch-bondi"
 },
 "SOCIETY": [
  {
   "img": "real/khaleesi-muttini.jpg",
   "caption": "Khaleesi, Head of Yappy Hour",
   "name": "Muttini",
   "handle": "muttini"
  },
  {
   "img": "real/jackrussell-tray.jpg",
   "caption": "Table service, please.",
   "name": "Bark N’ Bourbon",
   "handle": "bark-n-bourbon"
  },
  {
   "img": "real/khaleesi-bondi.jpg",
   "caption": "Dressed for the occasion.",
   "name": "Bondi Spritz",
   "handle": "bondi-spritz-the-post-play-refresher"
  },
  {
   "img": "real/fluffy-barkarita.jpg",
   "caption": "Light, bright and very fluffy.",
   "name": "Barkarita",
   "handle": "barkarita-1"
  },
  {
   "img": "real/khaleesi-jackhatten.jpg",
   "caption": "Shades on, Jackhatten poured.",
   "name": "Jackhatten",
   "handle": "jackhatten"
  },
  {
   "img": "real/jackrussell-lineup.jpg",
   "caption": "Choosing tonight’s pour.",
   "name": "Yappy Hour Sampler",
   "handle": "the-yappy-hour-sampler"
  },
  {
   "img": "real/khaleesi-bark.jpg",
   "caption": "Blue is her colour.",
   "name": "Bark N’ Bourbon",
   "handle": "bark-n-bourbon"
  },
  {
   "img": "real/tote-bondi-walk.jpg",
   "caption": "Bondi walks, 5pm tote.",
   "name": "5pm Tote",
   "handle": "5pm-tote"
  }
 ],
 "INGREDIENTS": [
  {
   "img": "ingr/coconut.jpg",
   "t": "Coconut Water",
   "p": "Natural hydration and electrolyte balance"
  },
  {
   "img": "ingr/broth.jpg",
   "t": "Beef & Chicken Broth",
   "p": "Hydration and collagen support"
  },
  {
   "img": "ingr/aloe.jpg",
   "t": "Purified Inner-Leaf Aloe Vera",
   "p": "Hydration and digestive comfort"
  },
  {
   "img": "ingr/omega.jpg",
   "t": "Omega-3 DHA/EPA",
   "p": "Joint, heart and brain nourishment"
  },
  {
   "img": "ingr/biotics.jpg",
   "t": "Pro & Prebiotics",
   "p": "Gut comfort and digestion"
  },
  {
   "img": "ingr/calm.jpg",
   "t": "L-Theanine & Passionflower",
   "p": "Calm and relaxation"
  },
  {
   "img": "ingr/collagen.jpg",
   "t": "Collagen & Biotin",
   "p": "Skin, coat and joint health"
  },
  {
   "img": "ingr/vitamins.jpg",
   "t": "L-Carnitine & B Vitamins",
   "p": "Energy and metabolism support"
  }
 ],
 "WHY": [
  {
   "t": "Sip-worthy recovery after play",
   "p": "A tasty hydration boost that helps pups bounce back after adventures, refreshed and ready for more mischief."
  },
  {
   "t": "Feel-good energy without the buzz",
   "p": "Calm vitality without the overstimulation. Just smooth, balanced goodness in every sip."
  },
  {
   "t": "A taste they keep coming back for",
   "p": "Light, delicious flavours dogs adore, keeping tongues slurping and glasses spotless."
  },
  {
   "t": "Hydration, as a shared ritual",
   "p": "A special bonding moment with your furbaby. Pour yours, pour theirs, unwind together."
  }
 ],
 "CHEERS": [
  "real/glass-0.jpg",
  "real/charcuterie-1.jpg",
  "real/sampler-0.jpg",
  "real/charcuterie-2.jpg",
  "real/tote-1.jpg",
  "real/drkate-0.jpg"
 ],
 "SPOTIFY": "4Mgqsy98M7lRCX2NjlrYEZ",
 "IG": "https://www.instagram.com/puptailsociety/",
 "TIKTOK": "https://www.tiktok.com/@puptailsociety",
 "FACEBOOK": "https://www.facebook.com/puptailsociety/",
 "RIMG": {
  "pts-dogs-way-freeze.jpg": [
   720,
   1200
  ],
  "pts-dogs-way-top.jpg": [
   720,
   1200
  ],
  "pts-events-bne-1.jpg": [
   720,
   960
  ],
  "pts-events-bne-2.jpg": [
   720,
   960
  ],
  "pts-events-bne-3.jpg": [
   720,
   960
  ],
  "pts-events-bne-4.jpg": [
   720,
   960
  ],
  "pts-events-bne-5.jpg": [
   720,
   960
  ],
  "pts-events-bne-6.jpg": [
   720,
   960
  ],
  "pts-events-syd-1.jpg": [
   720,
   960
  ],
  "pts-events-syd-2.jpg": [
   720,
   960
  ],
  "pts-events-syd-3.jpg": [
   720,
   960
  ],
  "pts-events-syd-4.jpg": [
   720,
   960
  ],
  "pts-events-syd-5.jpg": [
   720,
   960
  ],
  "pts-events-syd-6.jpg": [
   720,
   960
  ],
  "pts-luxe-charcuterie.jpg": [
   720,
   1206
  ],
  "pts-luxe-flatlay-m.jpg": [
   720,
   1080
  ],
  "pts-luxe-flatlay.jpg": [
   720,
   1280,
   2400
  ],
  "pts-luxe-gift.jpg": [
   720,
   1086
  ],
  "pts-luxe-giftcard-face.jpg": [
   720,
   1200
  ],
  "pts-luxe-giftcard.jpg": [
   720,
   1400
  ],
  "pts-luxe-glass.jpg": [
   720,
   1305
  ],
  "pts-luxe-heritage.jpg": [
   720,
   1305
  ],
  "pts-luxe-hero-mobile.jpg": [
   720,
   1200
  ],
  "pts-luxe-hero-wide.jpg": [
   720,
   1280,
   2800
  ],
  "pts-luxe-mixed.jpg": [
   720,
   1305
  ],
  "pts-luxe-pawty.jpg": [
   720,
   1305
  ],
  "pts-luxe-ritual.jpg": [
   720,
   1024
  ],
  "pts-luxe-society.jpg": [
   720,
   1206
  ],
  "pts-luxe-yappy-cream.jpg": [
   720,
   1200
  ],
  "pts-luxe-yappy.jpg": [
   720,
   1200
  ],
  "pts-pack-bark-n-bourbon-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-barkarita-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-bondi-spritz-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-brosecco-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-jackhatten-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-muttini-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-negruffi-luxe.jpg": [
   720,
   1200
  ],
  "pts-pack-tailgroni-luxe.jpg": [
   720,
   1200
  ],
  "pts-real-charcuterie-0.jpg": [
   720,
   1206
  ],
  "pts-real-charcuterie-1.jpg": [
   720,
   1086
  ],
  "pts-real-charcuterie-2.jpg": [
   720,
   1206
  ],
  "pts-real-colour-bark.jpg": [
   720,
   1024
  ],
  "pts-real-colour-bondi.jpg": [
   720,
   1024
  ],
  "pts-real-colour-brosecco.jpg": [
   720,
   1024
  ],
  "pts-real-colour-jack.jpg": [
   720,
   1024
  ],
  "pts-real-colour-muttini.jpg": [
   720,
   1024
  ],
  "pts-real-colour-negruffi.jpg": [
   720,
   1024
  ],
  "pts-real-drkate-0.jpg": [
   720,
   1280,
   2746
  ],
  "pts-real-fluffy-barkarita.jpg": [
   720,
   1313
  ],
  "pts-real-giftcard-0.jpg": [
   720,
   1280
  ],
  "pts-real-glass-1.jpg": [
   720,
   1305
  ],
  "pts-real-jackrussell-lineup.jpg": [
   720,
   1313
  ],
  "pts-real-jackrussell-tray.jpg": [
   720,
   1305
  ],
  "pts-real-khaleesi-bark.jpg": [
   720,
   1305
  ],
  "pts-real-khaleesi-bondi.jpg": [
   720,
   1305
  ],
  "pts-real-khaleesi-jackhatten.jpg": [
   720,
   1305
  ],
  "pts-real-khaleesi-muttini.jpg": [
   720,
   1305
  ],
  "pts-real-launch-barkarita.jpg": [
   720,
   1305
  ],
  "pts-real-launch-bondi.jpg": [
   720,
   1305
  ],
  "pts-real-launch-negruffi.jpg": [
   720,
   1305
  ],
  "pts-real-launch-tailgroni.jpg": [
   720,
   1305
  ],
  "pts-real-pawty-pack-1.jpg": [
   720,
   1305
  ],
  "pts-real-review-carrie.jpg": [
   720,
   946
  ],
  "pts-real-review-mary.jpg": [
   720,
   960
  ],
  "pts-real-review-sally.jpg": [
   720,
   960
  ],
  "pts-real-sampler-0.jpg": [
   720,
   1313
  ],
  "pts-real-sampler-1.jpg": [
   720,
   1305
  ],
  "pts-real-sampler-2.jpg": [
   720,
   1305
  ]
 },
 "RRAT": {
  "pts-dogs-way-freeze.jpg": 1.25,
  "pts-dogs-way-top.jpg": 1.2417,
  "pts-events-bne-1.jpg": 1.25,
  "pts-events-bne-2.jpg": 1.25,
  "pts-events-bne-3.jpg": 1.25,
  "pts-events-bne-4.jpg": 1.25,
  "pts-events-bne-5.jpg": 1.25,
  "pts-events-bne-6.jpg": 1.25,
  "pts-events-syd-1.jpg": 1.25,
  "pts-events-syd-2.jpg": 1.25,
  "pts-events-syd-3.jpg": 1.25,
  "pts-events-syd-4.jpg": 1.25,
  "pts-events-syd-5.jpg": 1.25,
  "pts-events-syd-6.jpg": 1.25,
  "pts-luxe-charcuterie.jpg": 1.4992,
  "pts-luxe-flatlay-m.jpg": 1.25,
  "pts-luxe-flatlay.jpg": 0.5583,
  "pts-luxe-gift.jpg": 1.3333,
  "pts-luxe-giftcard-face.jpg": 1.25,
  "pts-luxe-giftcard.jpg": 1.2414,
  "pts-luxe-glass.jpg": 1,
  "pts-luxe-heritage.jpg": 1,
  "pts-luxe-hero-mobile.jpg": 1.2408,
  "pts-luxe-hero-wide.jpg": 0.4104,
  "pts-luxe-mixed.jpg": 1,
  "pts-luxe-pawty.jpg": 1,
  "pts-luxe-ritual.jpg": 1.5,
  "pts-luxe-society.jpg": 1.2595,
  "pts-luxe-yappy-cream.jpg": 1.2408,
  "pts-luxe-yappy.jpg": 1.2408,
  "pts-pack-bark-n-bourbon-luxe.jpg": 1.25,
  "pts-pack-barkarita-luxe.jpg": 1.25,
  "pts-pack-bondi-spritz-luxe.jpg": 1.25,
  "pts-pack-brosecco-luxe.jpg": 1.25,
  "pts-pack-jackhatten-luxe.jpg": 1.25,
  "pts-pack-muttini-luxe.jpg": 1.25,
  "pts-pack-negruffi-luxe.jpg": 1.25,
  "pts-pack-tailgroni-luxe.jpg": 1.25,
  "pts-real-charcuterie-0.jpg": 1.4992,
  "pts-real-charcuterie-1.jpg": 1.3333,
  "pts-real-charcuterie-2.jpg": 1.2595,
  "pts-real-colour-bark.jpg": 1.5,
  "pts-real-colour-bondi.jpg": 1.5,
  "pts-real-colour-brosecco.jpg": 1.5,
  "pts-real-colour-jack.jpg": 1.5,
  "pts-real-colour-muttini.jpg": 1.5,
  "pts-real-colour-negruffi.jpg": 1.5,
  "pts-real-drkate-0.jpg": 0.445,
  "pts-real-fluffy-barkarita.jpg": 0.7357,
  "pts-real-giftcard-0.jpg": 0.6664,
  "pts-real-glass-1.jpg": 1,
  "pts-real-jackrussell-lineup.jpg": 0.7357,
  "pts-real-jackrussell-tray.jpg": 1,
  "pts-real-khaleesi-bark.jpg": 1,
  "pts-real-khaleesi-bondi.jpg": 1,
  "pts-real-khaleesi-jackhatten.jpg": 1,
  "pts-real-khaleesi-muttini.jpg": 1,
  "pts-real-launch-barkarita.jpg": 1,
  "pts-real-launch-bondi.jpg": 1,
  "pts-real-launch-negruffi.jpg": 1,
  "pts-real-launch-tailgroni.jpg": 1,
  "pts-real-pawty-pack-1.jpg": 1,
  "pts-real-review-carrie.jpg": 1.5222,
  "pts-real-review-mary.jpg": 1.3333,
  "pts-real-review-sally.jpg": 1.3333,
  "pts-real-sampler-0.jpg": 0.7357,
  "pts-real-sampler-1.jpg": 1,
  "pts-real-sampler-2.jpg": 1
 }
};
